import styled from 'styled-components/macro'
import { handleFormError } from '../../../utils/handleFormError'
import { TextInput } from '../../../components/FormUtils/TextInput'
import { useForm } from 'react-hook-form'
import { useAuth } from 'context/authentication/useAuth'
import to from 'await-to-js'
import { useState } from 'react'
import FbButton from '../../../components/FbUI/FbButton'

function ResetPassword() {
  const { resetPassword } = useAuth()
  const [successMsg, setSuccessMsg] = useState('')

  const {
    control,
    handleSubmit,
    formState: { isSubmitting },
    setError,
  } = useForm({
    defaultValues: {
      email: '',
      non_field_errors: '',
    },
  })

  const onSubmit = handleSubmit(
    async (values) => {
      setSuccessMsg('')
      const [err, res] = await to(resetPassword(values.email))
      handleFormError(err, setError)
      setSuccessMsg(res?.detail ?? '')
    },
    (errors) => console.warn(errors)
  )

  return (
    <Content>
      <div className="text-[22px] font-light text-new-company-gray-500">
        Welcome to{' '}
        <span className="text-new-company-green-dark font-semibold">
          First Bite
        </span>
      </div>
      <h1 className="text-[18px] mb-2 mt-4">Reset Password</h1>
      {successMsg && <p className="mb-4">{successMsg}</p>}
      <TextInput control={control} name="email" label="Email" />
      <FbButton
        type="submit"
        onClick={onSubmit}
        loading={isSubmitting}
        disabled={!!successMsg}
        className="w-full mt-4"
      >
        Reset Password
      </FbButton>
    </Content>
  )
}

const Content = styled.div`
  max-width: 400px;
  flexshrink: 0;
`

export default ResetPassword
